export interface ITaxInformation {
  taxNumber: string;
  vatNumber: string | undefined;
}

export class TaxInformation implements ITaxInformation {
  taxNumber: string = '';
  vatNumber: string | undefined = undefined;

  static parse(obj: any): TaxInformation {
    const taxInfo = new TaxInformation();
    Object.assign(taxInfo, obj);
    return taxInfo;
  }
}
